<div class="container">
        <div class="row no-gutters">
            <div class="col-12">
                <div class="d-flex popup-head align-items-center">
                    <div class="popup-title mr-auto" translate>lblAddDMSDefaultValues</div>
                    <div class="float-right">
                        <a class="close mr-3" (click)="OnClose()" translate>
                            <span class="" aria-hidden="true">&times;</span>
                        </a>
                    </div>
                </div>
                <form #f="ngForm" (ngSubmit)="AddDMSDefaultValues(dmsDefaultValuesInfo)">
                    <div class="card scrollbar">
                        <div class="card-content">
                            <div class="card-body">
                                <div class="form-row">
                                    <div class="col-6 af-form-group">
                                        <label for="template-edit-model" translate>lblDMSName<strong
                                                class="mlt6 required"> * </strong>
                                        </label>
                                        <div class="lbl-info">
                                            <input type="text" id="template-edit-model" name="model" #model="ngModel" 
                                                class="form-control" [(ngModel)]="dmsDefaultValuesInfo.DMSName" required
                                                 [ngClass]="{'is-invalid': model.invalid && model.touched}">
                                            <div *ngIf="model.invalid && (model.dirty || model.touched)"
                                                class="help-block text-danger">
                                                <div *ngIf="model.errors.required"><span
                                                        translate>lblDMSNameRequired</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="col-6 af-form-group">
                                        <label for="template-edit-company" translate>lblTableName<strong
                                                class="mlt6 required"> * </strong>
                                        </label>
                                        <div class="lbl-info">
                                            <input type="text" id="template-edit-model" name="Tablename"
                                                #Tablename="ngModel" class="form-control"
                                                [(ngModel)]="dmsDefaultValuesInfo.TableName" required 
                                                [ngClass]="{'is-invalid': Tablename.invalid && Tablename.touched}">
                                            <div *ngIf="Tablename.invalid && (Tablename.dirty || Tablename.touched)"
                                                class="help-block text-danger">
                                                <div *ngIf="Tablename.errors.required"><span
                                                        translate>lblTableNameRequired</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 af-form-group">
                                            <label for="template-edit-company" translate>lblDMSColumnName<strong
                                                    class="mlt6 required"> * </strong>
                                            </label>
                                            <div class="lbl-info">
                                                <input type="text" id="template-edit-model" name="DMSColumnname"
                                                    #DMSColumnname="ngModel" class="form-control"
                                                    [(ngModel)]="dmsDefaultValuesInfo.DMSColumnName" required 
                                                    [ngClass]="{'is-invalid': DMSColumnname.invalid && DMSColumnname.touched}">
                                                <div *ngIf="DMSColumnname.invalid && (DMSColumnname.dirty || DMSColumnname.touched)"
                                                    class="help-block text-danger">
                                                    <div *ngIf="DMSColumnname.errors.required"><span
                                                            translate>lblDMSColumnNameRequired</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
    
                                        <div class="col-6 af-form-group">
                                                <label for="template-edit-company" translate>lblDMSValues
                                                       
                                                </label>
                                                <div class="lbl-info">
                                                    <input type="text" id="template-edit-model" name="DMSvalues"
                                                        #DMSvalues="ngModel" class="form-control"
                                                        [(ngModel)]="dmsDefaultValuesInfo.DMSValues" >
                                                 
                                                </div>
                                            </div>

                                            <div class="col-6 af-form-group">
                                                    <label for="template-edit-company" translate>lblDMSColumnDataType
                                                          
                                                    </label>
                                                    <div class="lbl-info">
                                                        <input type="text" id="template-edit-model" name="DMSColumndataType"
                                                            #DMSColumndataType="ngModel" class="form-control"
                                                            [(ngModel)]="dmsDefaultValuesInfo.DMSColumnDataType" >
                                                    </div>
                                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-3 bg-light">
                        <div class="row">
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                                <button type="submit" class="btn btn-primary btn-lg  mr-sm-2"
                                    [disabled]="!f.valid" translate aria-label="Center Align">lblAdd</button>
                                <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
